<div class="accessibility-dialogs-new-help-center-decision-tree">
    <div class="mon-dialog-header">
        <page-header [header]="decisionTree.title"
                     [subHeader]="decisionTree.description">
        </page-header>
    </div>
    <div class="mon-dialog-body bg-white">
        <div class="decision-container max-height d-flex flex-column">
            <ul class="list-unstyled mt-2 mb-0 d-flex flex-column answer-list">
                <li *ngFor="let answer of getAnswers()" class="mb-2 answer-list-item">
                    <button class="btn btn-border-radius btn-secondary flat d-flex align-items-center max-width pl-4"
                            (click)="gotoAnswer(answer)"
                            type="button">
                        <span class="fas fa-circle fa-fw ml-1 mr-4 answer-list-item-icon text-link" aria-hidden="true"></span>
                        <span class="my-0 text-left answer-list-item-title mr-auto">{{answer.title}}</span>
                        <span class="ml-2 answer-list-item-answer" aria-hidden="true">{{answer.answerText}}</span>
                    </button>
                </li>
            </ul>
            <div class="row flex-nowrap py-3 solution" *ngIf="!hasSolution()">
                <div class="col-auto pl-7 pr-0">
                    <span class="fas fa-info-circle fa-2x fa-fw text-link" aria-hidden="true">
                    </span>
                </div>
                <h2 class="col pl-2 my-0">{{question?.title}}</h2>
                <div class="col-auto pr-6">
                    <button class="btn btn-border-radius btn-secondary mr-1"
                            (click)="addAnswer(question?.negative_action, question?.negative_text)"
                            type="button"
                            [monEventTrigger]="'actionTrigger'"
                            [monEventParams]="{action: 'decision-tree-choice-negative', params: {name: question?.negative_text}}">
                        {{question?.negative_text}}
                    </button>
                    <button class="btn btn-border-radius emphasised-btn"
                            (click)="addAnswer(question?.positive_action, question?.positive_text)"
                            type="button"
                            [monEventTrigger]="'actionTrigger'"
                            [monEventParams]="{action: 'decision-tree-choice-positive', params: {name: question?.positive_text}}">
                        {{question?.positive_text}}
                    </button>
                </div>
            </div>
            <div class="pl-4 pr-3 pt-2 flex-fill">
                <div *ngIf="!hasSolution()" class="pl-8 max-height scroll-y" [innerHTML]="question?.text"></div>
                <div *ngIf="hasSolution() && getLatestAnswer()"
                     class="bg-light-grey p-3 ml-6">
                    <p class="text-bold">{{ 'Our suggestion' | translate }}</p>
                    <p [innerHTML]="getLatestAnswer()?.answer?.solution_text"></p>
                </div>
            </div>
            <div class="align-self-end pr-3 py-3 pl-12">
                <p class="text-bold">{{ 'DISCLAIMER' | translate }}</p>
                <p class="text-italic font-size-0-9">
                    The suggestions provided are for informative and demonstrative purposes only.
                    You assume all risk in relying on such information, and agree Acquia Web Governance cannot be liable for the same.
                </p>
            </div>
        </div>
    </div>
</div>
